import React from 'react';
import classNames from 'classnames';

const PullQuote: React.SFC<PropDef> = ({ content, direction }) => (
  <blockquote
    className={classNames('pull-quote', {
      'pull-quote--left': direction === 'left',
      'pull-quote--right': direction === 'right',
    })}
  >
    {content}
  </blockquote>
);

interface PropDef {
  content: string;
  direction?: 'left' | 'right';
}

export default PullQuote;

